import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ProblemInstanceService } from '../services/problem-instance/problem-instance.service';
import { TaskToRequiredEmployees } from '../models/task-to-required-employees.model';
import { TaskUser } from '../models/task-user.model';
import { VisitRestriction } from '../models/visit-restriction.model';
import { EmployeeWorkShift } from '../models';

@Component({
    selector: 'app-employees-restrictions-modal',
    templateUrl: './employees-restrictions-modal.component.html',
    styleUrls: ['./employees-restrictions-modal.component.scss'],
    standalone: false
})
export class EmployeesRestrictionsModalComponent {
    private readonly modalRef = inject(BsModalRef);
    private readonly problemInstanceService = inject(ProblemInstanceService);

    public set parameter(value: { taskId: string }) {
        this.taskId = value.taskId;
        this.problemInstanceService.getProblemInstance().subscribe(result => {
            this.mapRequiredEmployees(
                value.taskId,
                result.problemInstance.taskToReqEmployees,
                result.problemInstance.employeeWorkShifts
            );

            this.mapRestrictedEmployees(
                value.taskId,
                result.problemInstance.tasks,
                result.problemInstance.visitRestrictions,
                result.problemInstance.employeeWorkShifts
            );
        });
    }

    public taskId: string;
    public requiredEmployees: string[];
    public restrictedEmployees: string[];

    public dismissModal(): void {
        this.modalRef.hide();
    }

    private mapRequiredEmployees(
        taskId: string,
        requiredEmployees: TaskToRequiredEmployees[],
        employees: EmployeeWorkShift[]
    ): void {
        const reqEmployees = requiredEmployees.find(i => i.taskId === taskId);
        if (reqEmployees) {
            this.requiredEmployees = reqEmployees.employeeIds.map(id => {
                const employee = employees.find(i => i.employeeId === id);
                return employee ? employee.employeeName : '';
            });
        }
    }

    private mapRestrictedEmployees(
        taskId: string,
        tasks: TaskUser[],
        visitRestrictions: VisitRestriction[],
        employees: EmployeeWorkShift[]
    ): void {
        const task = tasks.find(i => i.taskId === taskId);
        if (task) {
            const employeeIds = visitRestrictions.filter(i => i.patientId === task.patientId).map(i => i.employeeId);
            this.restrictedEmployees = employeeIds.map(id => {
                const employee = employees.find(i => i.employeeId === id);
                return employee ? employee.employeeName : '';
            });
        }
    }
}
